import { render, staticRenderFns } from "./NotificationStatusComponent.vue?vue&type=template&id=30cdcf67&scoped=true"
import script from "./NotificationStatusComponent.vue?vue&type=script&lang=js"
export * from "./NotificationStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdcf67",
  null
  
)

export default component.exports